import AssetBulkUpdate from "./AssetBulkUpdate";

export default AssetBulkUpdate;